import { Loading, LoadingProps } from '@yoti/ui-kit-components-react/loading';
import style from './circularLoading.module.scss';
const DEFAULT_MESSAGE = 'Loading...';

export interface CircularLoadingProps extends LoadingProps {
    message?: string;
    'data-qa'?: string;
}

const CircularLoading = ({
    message,
    className,
    'data-qa': dataQa = 'circular-loading',
}: CircularLoadingProps) => {
    return (
        <div className={style.loading} data-qa={dataQa}>
            <Loading className={className} />
            <span data-qa="circular-loading-message">{message ? message : DEFAULT_MESSAGE}</span>
        </div>
    );
};

export default CircularLoading;
